// v2
export const getUTMParameters = (methods) => {
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source');
    const utmMedium = urlParams.get('utm_medium');
    const utmCampaign = urlParams.get('utm_campaign');
    const currentUrl = window.location.href; // Use href to include the full URL including query parameters
  
    // Check and set each UTM parameter individually, also store in session storage
    if (utmSource) {
      //console.log('Setting UTMSource:', utmSource);
      if (methods) methods.setValue('UTMSource', utmSource);
      sessionStorage.setItem('utm_source', utmSource);
    }
    if (utmMedium) {
      //console.log('Setting UTMMedium:', utmMedium);
      if (methods) methods.setValue('UTMMedium', utmMedium);
      sessionStorage.setItem('utm_medium', utmMedium);
    }
    if (utmCampaign) {
      //console.log('Setting UTMCampaign:', utmCampaign);
      if (methods) methods.setValue('UTMCampaign', utmCampaign);
      sessionStorage.setItem('utm_campaign', utmCampaign);
    }
  
    // Set the full URL including any existing query parameters
    //console.log('Setting pageUrl:', currentUrl);
    if (methods) methods.setValue('pageUrl', currentUrl);
    sessionStorage.setItem('page_url', currentUrl);
  
    // Log the UTM parameters from session storage
    // console.log('UTM Parameters in Session Storage:', {
    //   utm_source: sessionStorage.getItem('utm_source'),
    //   utm_medium: sessionStorage.getItem('utm_medium'),
    //   utm_campaign: sessionStorage.getItem('utm_campaign'),
    //   page_url: sessionStorage.getItem('page_url'),
    // });
  };
  